module.exports = __webpack_public_path__ + "static/gallery_treehouse_5-961d56315638487c66b7a203e520dd5f.jpg";